import React from "react";
import { Link } from "react-router-dom";
import { siteConfig } from "../Datas/productData";
import "../css/returns.scss";

function Returns() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <main className="policy-page returns">
      <header className="policy-hero">
        <p className="policy-eyebrow">Customer care</p>
        <h1>Returns &amp; refunds</h1>
        <p>
          Changed your mind? Here is what a considered, straightforward return
          would look like in the {siteConfig.brandName} storefront experience.
        </p>
      </header>

      <div className="policy-layout">
        <nav className="policy-nav" aria-label="Customer care pages">
          <p>How can we help?</p>
          <Link to="/shipping" onClick={toTop}>
            Shipping &amp; delivery <span aria-hidden="true">→</span>
          </Link>
          <Link className="is-active" to="/returns" aria-current="page">
            Returns &amp; refunds <span aria-hidden="true">→</span>
          </Link>
          <Link to="/contact" onClick={toTop}>
            Contact us <span aria-hidden="true">→</span>
          </Link>
        </nav>

        <article className="policy-content">
          <aside className="policy-demo-note">
            <strong>Demo storefront</strong>
            <p>
              No payments are captured and no returns can be lodged here. This
              original policy copy demonstrates a production-ready page layout.
            </p>
          </aside>

          <section className="policy-intro" aria-labelledby="returns-overview">
            <p className="policy-eyebrow">The essentials</p>
            <h2 id="returns-overview">A 30-day return window.</h2>
            <p>
              In a live store, eligible items could be requested for return
              within 30 days of delivery. They would need to be unused, with
              original tags, packaging, and proof of purchase intact.
            </p>
          </section>

          <section className="policy-cards" aria-label="Return highlights">
            <div>
              <span>01</span>
              <h3>30 days</h3>
              <p>From confirmed delivery to request an eligible return.</p>
            </div>
            <div>
              <span>02</span>
              <h3>Original condition</h3>
              <p>Unused, unwashed, and returned with all packaging.</p>
            </div>
            <div>
              <span>03</span>
              <h3>5–7 days</h3>
              <p>Illustrative refund processing after inspection.</p>
            </div>
          </section>

          <section className="policy-section" aria-labelledby="start-return">
            <div className="policy-section__heading">
              <span>01</span>
              <h2 id="start-return">How a return works</h2>
            </div>
            <ol className="policy-steps">
              <li>
                <span>1</span>
                <div>
                  <h3>Send your request</h3>
                  <p>
                    Contact customer care with the order number, item name, and
                    reason for return before sending anything back.
                  </p>
                </div>
              </li>
              <li>
                <span>2</span>
                <div>
                  <h3>Pack it carefully</h3>
                  <p>
                    Reuse the original protective packaging where possible and
                    include the return reference provided by the team.
                  </p>
                </div>
              </li>
              <li>
                <span>3</span>
                <div>
                  <h3>Keep your tracking</h3>
                  <p>
                    Use a tracked service. Return shipping remains the sender’s
                    responsibility unless an item arrived faulty or incorrect.
                  </p>
                </div>
              </li>
            </ol>
          </section>

          <section className="policy-section" aria-labelledby="return-condition">
            <div className="policy-section__heading">
              <span>02</span>
              <h2 id="return-condition">Condition &amp; exclusions</h2>
            </div>
            <p>
              Items with wear, fragrance, marks, missing components, or damaged
              packaging may not qualify. For hygiene and personalisation
              reasons, earrings, opened drinkware, gift cards, and customised or
              final-sale pieces would ordinarily be non-returnable unless faulty.
            </p>
            <p>
              Colour can vary slightly between displays. Our team would review
              genuine defects individually and ask for clear photographs before
              recommending the next step.
            </p>
          </section>

          <section className="policy-section" aria-labelledby="return-refunds">
            <div className="policy-section__heading">
              <span>03</span>
              <h2 id="return-refunds">Refunds &amp; exchanges</h2>
            </div>
            <p>
              Once approved, a refund would be issued to the original payment
              method. Original delivery charges, duties, and return postage are
              generally not refundable. Banks may require additional time to
              display the credit.
            </p>
            <p>
              Direct exchanges are not simulated. The clearest production flow
              would be to return an eligible item and place a fresh order for the
              preferred colour or size.
            </p>
          </section>

          <section className="policy-help" aria-labelledby="return-help">
            <div>
              <p className="policy-eyebrow">Ready to begin?</p>
              <h2 id="return-help">Tell us what did not work.</h2>
            </div>
            <Link to="/contact" onClick={toTop}>
              Contact customer care <span aria-hidden="true">↗</span>
            </Link>
          </section>
        </article>
      </div>
    </main>
  );
}

export default Returns;
